import React, { useEffect, useState } from 'react';
import { mapErrorResponseToArray } from '../../utils/index';
import ErrorMessage from './ErrorMessage';
import { v1 } from 'uuid';

const errorCodeManager: any = {
  COMPLEX: {
    errorDataMapper: mapErrorResponseToArray,
    errorComponent: (errors: any) =>
      errors.map(({ value, key }: any) => (
        <ErrorMessage key={v1()} message={`${key.split('_').join(' ')}: ${value}`} />
      )),
  },
  PLAIN: {
    errorDataMapper: (data: any) => data,
    errorComponent: (detail: any = 'Something went wrong!') => <ErrorMessage message={detail} />,
  },
  401: {
    errorDataMapper: (data: any) => data,
    errorComponent: (detail: any = 'Something went wrong!') => <ErrorMessage message={detail} />,
  },
  404: {
    errorDataMapper: (data: any) => data,
    errorComponent: (detail: any = 'Something went wrong!') => <ErrorMessage message={detail} />,
  },
};

const ErrorManager: React.FC<any> = ({ error }: any) => {
  const [errors, setErrors] = useState<any>({ status: '', data: '' });

  const ErrorMessageProvider = (statusCode: number) => {
    if (errorCodeManager[statusCode]) {
      const { errorDataMapper, errorComponent } = errorCodeManager[statusCode];
      const errorsMessage = errorDataMapper(errors.data);
      return () => errorComponent(errorsMessage);
    } else {
      return () => <ErrorMessage message={errors.data} />;
    }
  };

  useEffect(() => {
    try {
      const {
        data: { error_code = '', details = '', errorCode = '' },
      } = error;
      setErrors({ status: error_code ? error_code : errorCode, data: details });
    } catch (err) {
      setErrors({ status: '', data: '' });
    }
  }, [error]);

  return (
    <>
      {errors.data && errors.status ? (
        ErrorMessageProvider(errors.status)()
      ) : (
        <ErrorMessage message={typeof error === 'string' ? error : ''} />
      )}
    </>
  );
};

export default ErrorManager;
